import Vue from "vue";
import App from "./App.vue";
import "@/assets/css/tailwind.css";
import VueAgile from "vue-agile";

// Backend imports
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueAgile);

// Backend
Vue.use(VueAxios, axios);
Vue.use(VueSimpleAlert);

// URL for our API
axios.defaults.baseURL = 'https://us-central1-vd-send-emails.cloudfunctions.net/app/api'

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
